export const SystemEventTypes = {
    UNSPECIFIED: -1,
    STUDENT_HOUSING: -10000,
    WORKFLOW: -20000,
} as const;
